export default __webpack_public_path__ + "static/media/github.d6bb2e20.svg";